function qProvider($qProvider) {
  'ngInject';
      $qProvider.errorOnUnhandledRejections(false);
}

export default  qProvider;


